import * as CryptoJS from 'crypto-js';

export class EncryptionHelper {
    // Use the same key and IV as in the C# code
    private static readonly key = CryptoJS.enc.Utf8.parse('73980085041234569081836037373980'); // Same key as C#
    private static readonly iv = CryptoJS.enc.Utf8.parse('9081836037373980'); // Same IV as C#
    // public static decrypt(encryptedText: string): string {
    //     const decrypted = CryptoJS.AES.decrypt(encryptedText, this.key, {
    //         iv: this.iv,
    //         mode: CryptoJS.mode.CBC,
    //         padding: CryptoJS.pad.Pkcs7
    //     });

    //     return decrypted.toString(CryptoJS.enc.Utf8);
    // }
    public static decrypt(encryptedText: any): string {
        const decrypted = CryptoJS.AES.decrypt(encryptedText, this.key, {
            iv: this.iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        const decryptedString = decrypted.toString(CryptoJS.enc.Utf8);
        if (!isNaN(Number(decryptedString))) {
            Number(decryptedString); // Convert string to number if it is numeric
        }
        return decryptedString;  // Otherwise return it as a string
    }
}